export enum ReportEvents {
  REPORT_GENERATED = "report_generated",
  REPORT_VIEWED = "report_viewed",
  REPORT_EXPORTED = "report_exported",
  REPORT_SHARED = "report_shared",
  REPORT_FILTER_APPLIED = "report_filter_applied",
  DASHBOARD_VIEWED = "report_dashboard_viewed",
  METRIC_CLICKED = "report_metric_clicked",
  REPORT_FILTERED = "report_filtered",
  DATE_RANGE_CHANGED = "report_date_range_changed",
}